// src/config/environment.ts
// Configurações baseadas em variáveis de ambiente

export const config = {
  // Ambiente atual
  environment: process.env.REACT_APP_ENVIRONMENT || 'development',
  
  emulators: {
    host: process.env.REACT_APP_FIREBASE_EMULATOR_HOST || 'localhost',
    functions: {
      enabled: process.env.REACT_APP_USE_FUNCTIONS_EMULATOR === 'true',
      port: parseInt(process.env.REACT_APP_FUNCTIONS_EMULATOR_PORT || '5001'),
    },
    storage: {
      enabled: process.env.REACT_APP_USE_STORAGE_EMULATOR === 'true',
      port: parseInt(process.env.REACT_APP_STORAGE_EMULATOR_PORT || '9199'),
    },
    firestore: {
      enabled: process.env.REACT_APP_USE_FIRESTORE_EMULATOR === 'true',
      port: parseInt(process.env.REACT_APP_FIRESTORE_EMULATOR_PORT || '8080'),
    },
  },
  
  // Configurações do Firebase (se você quiser sobrescrever via env)
  firebase: {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyD8Zr-mMwHhl9Mtw-LkcXhDYV3To2lUXkk",
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "constela-aa835.firebaseapp.com",
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "constela-aa835",
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "constela-aa835.firebasestorage.app",
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "652126749881",
    appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:652126749881:web:bef8fba7ec93be105a0768",
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || "https://constela-aa835-default-rtdb.firebaseio.com",
  },
  
  // Configurações da API
  api: {
    baseUrl: process.env.REACT_APP_API_BASE_URL || '',
  },
  
  // Configurações de debug
  debug: process.env.REACT_APP_DEBUG_MODE === 'true',
  
  // Helpers
  isDevelopment: () => config.environment === 'development',
  isProduction: () => config.environment === 'production',
};

export default config;